import { render, staticRenderFns } from "./ShortageItemList.vue?vue&type=template&id=64d8dc7c&"
import script from "./ShortageItemList.vue?vue&type=script&lang=js&"
export * from "./ShortageItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports